// extracted by mini-css-extract-plugin
export var header = "styles-module--header--Q-pMU";
export var headline = "styles-module--headline--Veko3";